export const easeOutCubic = (t: number): number => 1 - Math.pow(1 - t, 3);
export const easeOutBack = (t: number): number => {
  const c1 = 1.70158;
  const c3 = c1 + 1;
  return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2);
};

type Tween = { t: number; duration: number; ease: (t: number) => number; onUpdate: (k: number) => void; resolve: () => void };

/** 以毫秒推进的补间集合；onUpdate 收到缓动后的进度 k（最后一次一定是 ease(1)） */
export class Tweens {
  private list: Tween[] = [];

  add(durationMs: number, onUpdate: (k: number) => void, ease: (t: number) => number = easeOutCubic): Promise<void> {
    return new Promise((resolve) => {
      this.list.push({ t: 0, duration: Math.max(1, durationMs), ease, onUpdate, resolve });
      onUpdate(ease(0));
    });
  }

  update(dtMs: number): void {
    const done: Tween[] = [];
    for (const tw of [...this.list]) {
      if (!this.list.includes(tw)) continue; // 已被 clear() 等移除，别覆盖其终值
      tw.t = Math.min(tw.duration, tw.t + dtMs);
      tw.onUpdate(tw.ease(tw.t / tw.duration));
      if (tw.t >= tw.duration) done.push(tw);
    }
    if (done.length) {
      this.list = this.list.filter((tw) => !done.includes(tw));
      done.forEach((tw) => tw.resolve());
    }
  }

  /** 立即结束全部补间：落到终值并 resolve，避免等待者永远挂起 */
  clear(): void {
    const all = this.list;
    this.list = [];
    let failed = false;
    let error: unknown;
    for (const tw of all) {
      try {
        tw.onUpdate(tw.ease(1));
      } catch (e) {
        if (!failed) { failed = true; error = e; }
      } finally {
        tw.resolve();
      }
    }
    if (failed) throw error;
  }

  get active(): number {
    return this.list.length;
  }
}
